export default Object.freeze({
  getBlob: {
    GET: () => {
      return `blobs`;
    },
  },
  getBlobSaleOffersAnnouncements: {
    GET: () => {
      return `blobs/saleOffer`;
    },
  },
  getBlobSaleMaritalStatus: {
    GET: () => {
      return `blobs/maritalStatus`;
    },
  },
  getBlobAnnouncement: {
    GET: () => {
      return `blobs/announcement`;
    },
  },
  getBlobRegistryEntry: {
    GET: () => {
      return `blobs/registryEntry`;
    },
  },
  getBlobSalesOfferAttachment: {
    GET: () => {
      return `blobs/salesoffer`;
    },
  },
  deleteBlob: {
    GET: (fileName) => {
      return `blobs/${fileName}`;
    },
  },
});
